export default {
  ADD_DATA: (state, payload) => {
    state.data = payload
  }
}